// extracted by mini-css-extract-plugin
export var button = "_o1-2";
export var card = "_o1-0";
export var closeButtonContainer = "_o1-3";
export var iconContainer = "_o1-1";